module.exports = __webpack_public_path__ + "static/media/derp-notification.b5640d32.png";